<div *ngIf="ready$ | async; else loadingTemplate" class="contents">
  <ng-container *ngIf="!resetPassword; else resetPasswordTemplate">
    <ng-container *ngIf="user$ | async as user; else loginTemplate">
      <ng-container *ngIf="(acl$ | async) !== null">
        <ng-container *ngIf="userHasAccessToHisLastCompany(); else selectCompanyTemplate">
          <div *ngIf="breadcrumb$ | async as breadcrumb" class="contents dx-swatch dx-swatch-{{ navTheme$ | async }} glam-software">
            <dx-drawer id="tabsDrawer"
              openedStateMode="shrink"
              position="right"
              revealMode="slide"
              template="tabsDrawerTpl"
              [opened]="tabs['creation'].length > 0"
            >
              <!-- z-index just per sobre del del popup -->
              <div id="creationTab"
                  style="min-width: 320px"
                  class="h-screen max-h-screen shadow border-l border p-3 z-30 bg-white"
                  *dxTemplate="let data of 'tabsDrawerTpl'"
              >
                <gs-tabs-host-creation></gs-tabs-host-creation>
              </div>
              <div class="flex flex-col-reverse h-screen max-h-screen justify-between relative">
                <div class="flex-1 overflow-hidden">
                  <dx-drawer id="mainDrawer"
                    [ngClass]="{'with-alert': activeAlerts.length > 0}"
                    openedStateMode="overlap"
                    [hideOnOutsideClick]="true"
                    position="left"
                    revealMode="slide"
                    template="template"
                    [(opened)]="isDrawerOpen"
                  >
                    <div id="sidebar" class="h-full bg-gray-100" style="width: 235px" *dxTemplate="let data of 'template'">
                      <app-main-menu-panel (onNavigate)="isDrawerOpen = false"></app-main-menu-panel>
                    </div>
                    <router-outlet />
                    <dx-popup *ngIf="translationField$ | async as data"
                              [visible]="translatableField.ready"
                              width="auto" minWidth="360"
                              height="auto"
                              (onHiding)="translationField$.next(undefined)"
                              [title]="'field.translatableFieldEditorTitle' | translate:{field: data.entity[data.field]}"
                              [showCloseButton]="true"
                    >
                      <gs-translatable-field #translatableField
                                            [field]="data.field"
                                            [entity]="data.entity"
                                            [resource]="data.resource"
                                            [callback$]="data.callback$"
                      />
                    </dx-popup>
                    <dx-popup *ngIf="reportViewer.reportOptions$ | async as reportOptions"
                              [visible]="true"
                              [showCloseButton]="false"
                              [showTitle]="false"
                              width="auto"
                              height="auto"
                              (onHidden)="this.reportViewer.closeReport()"
                              [hideOnOutsideClick]="true"
                    >
                      <div *dxTemplate="let data of 'content'">
                        <div class="flex justify-between pb-3 border-b">
                          <dx-button icon="close" (onClick)="this.reportViewer.closeReport()"></dx-button>
                        </div>
                        <report-viewer [entityId]="reportOptions.entityId" [id]="reportOptions.reportId"></report-viewer>
                      </div>
                    </dx-popup>
                  </dx-drawer>
                </div>

                <div *ngIf="activeAlerts.length > 0" class="dx-toast-warning px-10 flex flex-col justify-center flex-initial h-7">
                  <dx-gallery
                    [dataSource]="activeAlerts"
                    width="100%"
                    [loop]="true"
                    [showIndicator]="false"
                    [showNavButtons]="false"
                    [animationEnabled]="true"
                    itemTemplate="alertTemplate"
                    [slideshowDelay]="7500"
                    [animationDuration]="2000"
                  >
                    <div *dxTemplate="let data of 'alertTemplate'">
                      <div class="flex h-full">
                        <span class="m-auto">{{ data.text }}</span>
                      </div>
                    </div>
                  </dx-gallery>
                </div>
                <nav @slide id="toolbar" class="flex-initial theme-{{ navTheme$ | async }}">
                  <div class="flex flex-row sm:gap-3">
                    <dx-button id="main-menu-toggle" stylingMode="text"
                              (onClick)="isDrawerOpen = !isDrawerOpen"
                              icon="apps"
                    ></dx-button>
                    <div *ngIf="companies$ | async as companies" class="my-auto hidden sm:block">
                      <!-- {{ (companies | filterBy:['id']:user.lastCompanyId)[0].fiscalName }} -->
                      <img [src]="breadcrumbLogo" class="h-auto" style="max-width: 10rem;" alt="logo">
                    </div>
                    <nav  class="flex my-auto">
                      <ol class="breadcrumb inline-flex space-x-2">
                        <li (click)="isDrawerOpen = !isDrawerOpen"  *ngFor="let item of breadcrumb" class="[&:not(:first-child)]:hidden sm:[&:not(:first-child)]:list-item first:font-bold cursor-pointer">
                          <span class="hidden sm:inline mr-1">|</span>
                          <span class="text items-baseline theme-{{ navTheme$ | async }}">
                            {{ ('menu.breadcrumb.' + item.label) | translate | ucfirst }}
                          </span>
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <div class="flex my-auto">
                    <app-global-search *ngIf="globalSearchVisible" [title]="'common.globalSearch' | translate" class="hidden sm:block my-auto" style="margin-right: 12px;"></app-global-search>
                    <dx-button *ngIf="homeVisible" stylingMode="text" [hint]="'menu.home' | translate" icon="home" routerLink="/common/homes" class="my-auto"></dx-button>
                    <dx-menu class="my-auto" (onItemClick)="onMenuItemClick($event)">
                      <dxi-item *ngIf="fastReleaseVisible" icon="add">
                        <div *dxTemplate>
                          <dx-button stylingMode="text" [hint]="'menu.fastRelease.fastRelease' | translate" icon="add"></dx-button>
                        </div>
                        <dxi-item [dataField]="{ f: 'createOrganizationClicked' }" icon="corporate_fare" [text]="'menu.fastRelease.createOrganization' | translate | ucfirst"></dxi-item>
                        <dxi-item [dataField]="{ f: 'createPersonClicked' }" icon="group" [text]="'menu.fastRelease.createPerson' | translate | ucfirst"></dxi-item>
                        <dxi-item [dataField]="{ f: 'createProductClicked' }" icon="product" [text]="'menu.fastRelease.createProduct' | translate | ucfirst"></dxi-item>
                        <dxi-item [dataField]="{ f: 'createProjectClicked' }" icon="account_balance" [text]="'menu.fastRelease.createProject' | translate | ucfirst"></dxi-item>
                      </dxi-item>
                      <dxi-item *ngIf="favoriteMenuOptions$ | async as favOptions">
                        <div *dxTemplate>
                          <dx-button *ngIf="favoriteOptionsVisible" stylingMode="text" [hint]="'menu.favoriteOptions' | translate" icon="star"></dx-button>
                        </div>
                        <dxi-item class="submenu">
                          <dx-menu orientation="vertical" (onItemClick)="favoriteMenuOptionClicked($any($event.itemData).dataField)">
                            <dxi-item *ngFor="let item of favOptions"
                                      [icon]="item?.icon || ''"
                                      [text]="('menu.slideMenu.' + (item?.title || '')) | translate | ucfirst"
                                      [dataField]="item"
                            ></dxi-item>
                          </dx-menu>
                        </dxi-item>
                      </dxi-item>
                      <dxi-item *ngIf="plannerVisible" icon="view_timeline">
                        <div *dxTemplate>
                          <div class="relative">
                            <dx-button stylingMode="text" [hint]="'menu.planning' | translate" icon="calendar_month"></dx-button>
                          </div>
                        </div>
                        <dxi-item
                          *ngIf="canSeeoperationPlanning && (acl$ | async)!.includes('productionOrders-operative:editor')"
                          icon="view_timeline"
                          dataField="/common/planning"
                          [text]="'menu.operationPlanning' | translate | ucfirst">
                        </dxi-item>
                        <dxi-item
                          *ngIf="(acl$ | async)!.includes('serviceOrders-planning:editor')"
                          icon="calendar_month"
                          dataField="/common/workers-planning"
                          [text]="'menu.breadcrumb.workersPlanning' | translate | ucfirst">
                        </dxi-item>
                      </dxi-item>
                      <dxi-item icon="timer">
                        <div *dxTemplate>
                          <div class="relative">
                            <dx-button stylingMode="text" [hint]="'menu.timesheet.timesheet' | translate" icon="timer"></dx-button>
                            <div *ngIf="activeTimeTikets.length > 0"
                              class="text-white text-xs absolute bg-danger rounded-full -bottom-0 -right-0 px-1.5"
                                >{{ '1' }}
                            </div>
                          </div>
                        </div>
                        @if (clockingTerminalVisible) {
                          <dxi-item icon="fingerprint" dataField="/common/clocking-terminal" [text]="'menu.timesheet.clocking' | translate | ucfirst"></dxi-item>
                        }
                        <dxi-item icon="list_alt" dataField="/common/timers" [text]="'menu.timesheet.timers' | translate | ucfirst"></dxi-item>
                        <dxi-item icon="calendar_month" dataField="/common/calendar" [text]="'menu.timesheet.calendar' | translate | ucfirst">
                        </dxi-item>
                      </dxi-item>
                      <dxi-item *ngIf="appointmentsVisible">
                        <div *dxTemplate>
                          <dx-button *ngIf="appointmentsVisible" stylingMode="text" [hint]="'menu.appointments' | translate" routerLink="/common/appointments">
                            <div *dxTemplate="let content of 'content'">
                              <div class="relative">
                                <span icon="acute"></span>
                                <div *ngIf="activeAppointments > 0"
                                      class="text-white text-xs absolute bg-danger rounded-full -bottom-1 -right-1 px-1"
                                >{{ activeAppointments }}</div>
                              </div>
                            </div>
                          </dx-button>
                        </div>
                      </dxi-item>
                      <dxi-item *ngIf="(acl$ | async)!.includes('system')">

                        <div *dxTemplate>
                          <dx-button stylingMode="text" [hint]="'menu.preferences.preferences' | translate" icon="settings"></dx-button>
                        </div>
                        <dxi-item icon="settings" [text]="'menu.preferences.generalConfiguration' | translate | ucfirst">
                          <dxi-item *ngIf="companiesVisible" icon="apartment" dataField="/admin/companies" [text]="'menu.preferences.companies' | translate | ucfirst"></dxi-item>
                          <dxi-item *ngIf="languagesVisible" icon="language" dataField="/admin/languages" [text]="'menu.preferences.adminMenu.languages' | translate | ucfirst"></dxi-item>
                          <dxi-item *ngIf="currenciesVisible" icon="euro" dataField="/admin/currencies" [text]="'menu.preferences.adminMenu.currencies' | translate | ucfirst"></dxi-item>
                          <dxi-item *ngIf="countriesVisible" icon="flag" dataField="/admin/countries" [text]="'menu.preferences.adminMenu.countries' | translate | ucfirst"></dxi-item>
                          <dxi-item *ngIf="tagsVisible" icon="bookmark" dataField="/admin/tags" [text]="'menu.preferences.adminMenu.tags' | translate | ucfirst"></dxi-item>
                          <dxi-item *ngIf="translationsVisible" icon="translate" dataField="/admin/translations" [text]="'menu.preferences.adminMenu.translations' | translate | ucfirst"></dxi-item>
                          <dxi-item *ngIf="documentTypesVisible" icon="activefolder" dataField="/admin/document-types" [text]="'menu.preferences.adminMenu.documentTypes' | translate | ucfirst"></dxi-item>
                          <dxi-item *ngIf="customFieldsOrganizationsVisible || customFieldsPeopleVisible || customFieldsProductsVisible || customFieldsSuppliersVisible || customFieldsBatchesVisible" icon="reorder" dataField="/admin/custom-fields" [text]="'menu.preferences.customFields.customFields' | translate | ucfirst">
                            <dxi-item *ngIf="customFieldsOrganizationsVisible" icon="corporate_fare" dataField="/admin/custom-fields/organizations" [text]="'menu.preferences.customFields.organizations' | translate | ucfirst"></dxi-item>
                            <dxi-item *ngIf="customFieldsPeopleVisible" icon="group" dataField="/admin/custom-fields/people" [text]="'menu.preferences.customFields.people' | translate | ucfirst"></dxi-item>
                            <dxi-item *ngIf="customFieldsSuppliersVisible" icon="accessibility_new" dataField="/admin/custom-fields/customers" [text]="'menu.preferences.customFields.customers' | translate | ucfirst"></dxi-item>
                            <dxi-item *ngIf="customFieldsSuppliersVisible" icon="emoji_people" dataField="/admin/custom-fields/suppliers" [text]="'menu.preferences.customFields.suppliers' | translate | ucfirst"></dxi-item>
                            <dxi-item *ngIf="customFieldsProductsVisible" icon="inventory_2" dataField="/admin/custom-fields/products" [text]="'menu.preferences.customFields.products' | translate | ucfirst"></dxi-item>
                            <dxi-item *ngIf="customFieldsBatchesVisible" icon="more" dataField="/admin/custom-fields/batches" [text]="'menu.preferences.customFields.batches' | translate | ucfirst"></dxi-item>
                            <dxi-item *ngIf="documentTypes.length > 0" icon="docs" [text]="'menu.preferences.customFields.documents' | translate | ucfirst">
                              <dxi-item *ngFor="let documentType of documentTypes" icon="description" [dataField]="'/admin/custom-fields/documentTypes/' + documentType.id" [text]="documentType.name"></dxi-item>
                            </dxi-item>
                          </dxi-item>
                          <dxi-item *ngIf="reportsVisible || emailTemplatesVisible || paperSizeVisible" icon="content_copy" [text]="'menu.preferences.adminMenu.templates' | translate | ucfirst">
                            <dxi-item *ngIf="reportsVisible" icon="description" dataField="/admin/reports" [text]="'menu.preferences.adminMenu.printersDesing' | translate | ucfirst"></dxi-item>
                            <dxi-item *ngIf="emailTemplatesVisible" icon="mail" dataField="/admin/emailTemplates" [text]="'menu.preferences.adminMenu.emailTemplates' | translate | ucfirst"></dxi-item>
                            <dxi-item *ngIf="paperSizeVisible" icon="picture_in_picture" dataField="/admin/paperSizes" [text]="'menu.preferences.adminMenu.paperSizes' | translate | ucfirst"></dxi-item>
                          </dxi-item>
                          <dxi-item *ngIf="devicesVisible || printersVisible || scalesVisible" icon="devices_other" [text]="'menu.preferences.adminMenu.linkedDevices' | translate | ucfirst">
                            <dxi-item *ngIf="devicesVisible" icon="devices" dataField="/admin/devices" [text]="'menu.preferences.adminMenu.devices' | translate | ucfirst"></dxi-item>
                            <dxi-item *ngIf="printersVisible" icon="print" dataField="/admin/printers" [text]="'menu.preferences.adminMenu.printers' | translate | ucfirst"></dxi-item>
                            <dxi-item *ngIf="scalesVisible" icon="scale" dataField="/admin/scales" [text]="'menu.preferences.adminMenu.scales' | translate | ucfirst"></dxi-item>
                          </dxi-item>
                          <dxi-item *ngIf="alertsVisible || notificationsVisible || externalServiceNotificationsVisible" icon="notifications" [text]="'menu.preferences.adminMenu.notifications' | translate | ucfirst">
                            <dxi-item *ngIf="alertsVisible" icon="circle_notifications" dataField="/admin/alerts" [text]="'menu.preferences.adminMenu.alerts' | translate | ucfirst"></dxi-item>
                            <dxi-item *ngIf="notificationsVisible" icon="cast" dataField="/admin/notifications" [text]="'menu.preferences.adminMenu.userNotifications' | translate | ucfirst"></dxi-item>
                            <dxi-item *ngIf="externalServiceNotificationsVisible" icon="sync" dataField="/admin/external-services-notifications" [text]="'menu.preferences.adminMenu.externalServiceNotifications' | translate | ucfirst"></dxi-item>
                          </dxi-item>
                          <dxi-item *ngIf="eventsVisible" icon="feedback" dataField="/admin/events" [text]="'menu.preferences.adminMenu.events' | translate | ucfirst"></dxi-item>
                          <dxi-item *ngIf="tenantsVisible" icon="key" [dataField]="{f: 'showTenant'}" (click)="showTenant()" [text]="'menu.preferences.adminMenu.tenants' | translate | ucfirst"></dxi-item>
                        </dxi-item>
                        <dxi-item *ngIf="rolesVisible || usersVisible" icon="groups" dataField="/admin" [text]="'menu.preferences.userConfiguration' | translate | ucfirst">
                          <dxi-item *ngIf="rolesVisible" icon="manage_accounts" dataField="/admin/roles" [text]="'menu.preferences.roles' | translate | ucfirst"></dxi-item>
                          <dxi-item *ngIf="usersVisible" icon="people" dataField="/admin/users" [text]="'menu.preferences.users' | translate | ucfirst"></dxi-item>
                        </dxi-item>
                      </dxi-item>
                    </dx-menu>
                    <dx-menu  *ngIf="companies$ | async as companies" class="my-auto" (onItemClick)="onUserMenuItemClick($event)">
                      <dxi-item>
                        <div *dxTemplate>
                          <div class="flex" [title]="'menu.personalArea' | translate">
                            <div class="flex flex-col justify-between text-xs text-right">
                              <div class="min-w-48 h-4 uppercase font-semibold" style="font-size: 14px">
                                {{ (companies | filterBy:['id']:user.lastCompanyId)[0].fiscalName }}
                              </div>
                              <div>{{ user.name }} {{ user.surname }}</div>
                            </div>
                            <div>
                              <img [src]="user.imageUrl || '/assets/img/user-profile.svg'"
                                  class="w-8 h-8 rounded-full ml-2 object-cover object-center"
                                  [style.filter]="user.imageUrl === undefined || user.imageUrl === ''  || user.imageUrl === null
                                    ? 'invert(1000%)'
                                    : 'invert(0%)'"
                                  alt="profile-img"
                              >
                            </div>
                          </div>
                        </div>
                        <dxi-item [dataField]="{f: 'showProfile'}" icon="account_circle" (click)="showProfile(user)" [text]="'menu.admin.profile' | translate | ucfirst"></dxi-item>
                        <dxi-item *ngIf="companies" text="{{ 'menu.admin.companies' | translate | ucfirst }}"
                                  icon="apartment"
                        >
                        <!-- | filterBy:['stateId']:1 -->
                          <dxi-item *ngFor="let company of (companies | filterBy:['stateId']:1)"
                                    [onClick]="selectCompanyClick"
                                    icon="apartment"
                                    [text]="company.fiscalName"
                                    [dataField]="company"
                          ></dxi-item>
                        </dxi-item>
                        <dxi-item icon="logout" [dataField]="{f: 'logout'}" [text]="'common.logOut' | translate | ucfirst"></dxi-item>
                      </dxi-item>
                    </dx-menu>
                  </div>
                </nav>
                <div *ngIf="tabs['creation'].length > 0" style="z-index: 10; background-color: rgba(0, 0, 0, 0.32);" class="absolute left-0 top-0 w-full h-full"></div>
              </div>
            </dx-drawer>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-template #loginTemplate>
    <div id="popup-box">
      <div id="popup-box-inner">
        <app-login></app-login>
      </div>
    </div>
  </ng-template>

  <ng-template #resetPasswordTemplate>
    <div id="popup-box">
      <div id="popup-box-inner">
        <div class="flex justify-between pb-3 border-b">
          <div class="text-2xl font-bold">{{ 'common.resetPassword' | translate | ucfirst }}</div>
        </div>
        <app-reset-password
          [userName]="resetPasswordUserName"
          [oldPassword]="resetPasswordOldPassword"
          />
      </div>
    </div>
  </ng-template>



  <dx-popup *ngIf="isSelectingPrinter"
            [visible]="true"
            width="auto"
            style="min-width: 360px"
            height="auto"
            [showCloseButton]="true"
            [title]="'common.printerSelect' | translate"
            (onHidden)="isSelectingPrinter = false"
  >
    <dx-text-box *ngIf="pritersPopupShowUnits" class="mb-2" [(value)]="numberOfCopies" [label]="('common.numberOfCopies' | translate) | ucfirst"></dx-text-box>
    <dx-select-box #printerSelector
                   [dataSource]="printers$ | async"
                   displayExpr="description"
                   valueExpr="id"

    />
    <div class="mt-3 flex justify-end">
      <dx-button [text]="('common.print' | translate) | ucfirst"
          (onClick)="selectedPrinter$.next(printerSelector.value)"
      />
    </div>
  </dx-popup>

  <dx-popup *ngIf="isSelectingCustomReport"
            [visible]="true"
            width="500px"
            style="min-width: 360px"
            height="auto"
            [showCloseButton]="true"
            [title]="'common.printLabel' | translate"
            (onHidden)="isSelectingCustomReport = false; numberOfCopies = '1'"
            (onShown)="numberOfCopies = '1'"
  >
    <dx-text-box class="mb-2" [(value)]="numberOfCopies" [label]="('common.numberOfCopies' | translate) | ucfirst"></dx-text-box>
    <dx-lookup #customReportSelector
               [label]="'common.labels' | translate"
               [dataSource]="customReports$ | async"
               [value]="selectedReportId$ | async"
               displayExpr="reportName"
               itemTemplate="itemTemplate"
               fieldTemplate="itemTemplate"
               valueExpr="id">
      <div *dxTemplate="let element of 'itemTemplate'">
        @if(element){
          <div>{{element.reportName}}</div>
          <div>{{element.printerName}} ({{element.paperSizeName}})</div>
        }
      </div>
    </dx-lookup>
    <div class="mt-3 flex justify-end">
      <dx-button [text]="('common.print' | translate) | ucfirst"
                 [disabled]="!NumberOfCopiesIsValidNumber() || !customReportSelector.value"
                 (onClick)="selectedCustomReports$.next(customReportSelector.value)"
      />
    </div>
  </dx-popup>

  <dx-popup
    *ngIf="isSelectingPrinterSettingsForProducts" [visible]="true"
    [title]="'common.printerSelect' | translate"
    height="auto" width="400px"
    [showCloseButton]="true"
    (onHidden)="isSelectingPrinterSettingsForProducts = false; cancelSelectedPrinterSettingsForProducts$.next()"
    >
    <dx-text-box *ngIf="pritersPopupShowUnits" class="mb-2" [(value)]="numberOfCopies" [label]="('common.numberOfCopies' | translate) | ucfirst"></dx-text-box>
    <dx-select-box #printerSelector
      [dataSource]="printers$ | async"
      valueExpr="id" displayExpr="description"
      [value]="defaultPrinterSettingsForProducts?.printerId"
      />
    <dx-select-box #customReportSelector
      [dataSource]="productCustomReports"
      valueExpr="id" displayExpr="name"
      [value]="defaultPrinterSettingsForProducts?.customReportId"
      class="my-3"
      [label]="('common.customReport' | translate) | ucfirst"/>
    <div class="mt-3 flex justify-end">
      <dx-button [text]="('common.print' | translate) | ucfirst"
          [disabled]="!NumberOfCopiesIsValidNumber()"
          (onClick)="selectedPrinterSettingsForProducts$.next({
            printerId: printerSelector.value,
            customReportId: customReportSelector.value,
          })"
      />
    </div>
  </dx-popup>

  <ng-template #selectCompanyTemplate>
    <div id="popup-box">
      <div id="popup-box-inner" class="w-96">
        <span style="font-size: 28px!important;" class="font-normal  text-center mb-3">Select Company</span>
        <dx-list *ngIf="companies$ | async as companies"
                (onItemClick)="selectCompany($event.itemData)"
                [dataSource]="companies"
                displayExpr="fiscalName"
        ></dx-list>
      </div>
    </div>
  </ng-template>
</div>
<ng-template #loadingTemplate>
  <div id="popup-box">
    <dx-load-panel
      [visible]="true"
      [showIndicator]="true"
      [showPane]="true"
      [shading]="true"
      [hideOnOutsideClick]="false"
    >
    </dx-load-panel>
  </div>
</ng-template>
